import React        from 'react';
import PropTypes    from 'prop-types';
import Translations from '../../../utils/Translations';

class VipLabel extends React.Component {
	render() {
		if (!this.props.isVip) {
			return null;
		}

		return <span className="video-grid__item--label --vip"><span className="icon-actor -icon-person-princess"/>{Translations.get('VideoGridVip').toUpperCase()}</span>;
	}
}

VipLabel.propTypes = {
	isVip: PropTypes.bool,
};

export default VipLabel;